import * as React from 'react';
import {SSOSettingModel} from "../../model/SSOSetting";
import {IState as CommonState} from "../../common/State";
import {ExportButton} from "../../common";
import {RouteComponentProps} from "react-router";
import {ListBreadcrumb} from "./Data";
import { EditLink, ShowRecords, Icons} from "../../common";
import {ListForm, ListHeader, ListingLayout} from "../../layout/Listing";
import _ from "lodash";
import {list_key} from "../../helpers/OrderHelper";
import Filters from "./Filters";  

interface IState extends CommonState{
  pillars: Array<SSOSettingModel>;
   
}

export class SSOListing extends React.Component<RouteComponentProps, IState> {
  state: IState;
  records:React.RefObject<ShowRecords> = React.createRef();


  showContent = (data: SSOSettingModel, index: number) => {
   
    let cols = [];
    cols.push(...[
      <td>{index}</td>,
        this.records.current.createdTd("name", data.name),
        this.records.current.createdTd("client_id", data.client_id),
        this.records.current.createdTd(
                  "whitelisted_domains", 
                  Array.isArray(data.whitelisted_domains) 
                    ? data.whitelisted_domains.join("   ,   ") 
                    : data.whitelisted_domains
                ),
        this.records.current.createdTd("action", () =>  this.rowActionButtons(data))
    ]);
    cols = _.compact(cols);
    return (
      <tr key={list_key(data.id)}>{cols}</tr>
    );
  }

  filterRecords = (data?: any) => {
    if( this.records && this.records.current !== null){
      if(data !== undefined){
        this.records.current.setFormFields(data);
      }else {
        this.records.current.setFormFields();
      }
    }
  }


  rowActionButtons = (data: SSOSettingModel) => {
    return (
      <EditLink scope={'sso-setting.update'} to={`${this.props.match.url}/edit/${data.id}`} />
    )
  }

  render() {
    return (
        <ListingLayout breadcrumb={ListBreadcrumb}>
          <ListHeader title={"SSO Setting"} icon={Icons.file} >
            <ExportButton records={this.records} fileName={"SSO Setting"}/>
          </ListHeader>

          <ListForm
            form={<Filters getResults={this.filterRecords} />}
            table={(
              <ShowRecords
                url={"/settings/sso-setting"}
                showRecords={this.showContent}
                ref={this.records}
                isNeedAction={false}
                showCheckbox={false}
                rowActions={this.rowActionButtons}
               />
            )}
          />
        </ListingLayout>
    )
  }
}
